import { typedQueryClient, useTypedQuery } from "hooks";
import { DMSv3MonitoringDahsboardQueryKeys } from "modules/DMSv3/Monitoring/queryKeys";
import { DMSV3_MONITORING_STORAGE_KEYS } from "modules/DMSv3/Monitoring/storageKeys";
import { PAGE_SIZE, getPreference, setPreference } from "utils/common";

import type { OnChangeFn, PaginationState } from "@tanstack/react-table";
import type { DMSv3MonitoringFilters } from "modules/DMSv3/Monitoring/queryKeys";

const getDefaultFilters = (): DMSv3MonitoringFilters => ({
  dealer_id: undefined,
  dms_id: undefined,
  date_from: null,
  date_to: null,
  severity: undefined,
  source: undefined,
  dms_capability_id: undefined,
  page: 1,
  page_size: getPreference(DMSV3_MONITORING_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25)
});

export const useDMSv3MonitoringDashboardFilters = () => useTypedQuery({ queryKey: DMSv3MonitoringDahsboardQueryKeys.filters, initialData: getDefaultFilters() });

export const setFilters = (updatedFilters: DMSv3MonitoringFilters) => typedQueryClient.setQueryData(DMSv3MonitoringDahsboardQueryKeys.filters, updatedFilters);

export const setPage = (page: number) => {
  const currentFilters = typedQueryClient.getQueryData(DMSv3MonitoringDahsboardQueryKeys.filters);
  if (currentFilters) typedQueryClient.setQueryData(DMSv3MonitoringDahsboardQueryKeys.filters, { ...currentFilters, page });
};

export const handlePaginationChange: OnChangeFn<PaginationState> = updater => {
  const currentFilters = typedQueryClient.getQueryData(DMSv3MonitoringDahsboardQueryKeys.filters);
  if (currentFilters) {
    const newState = typeof updater === "function" ? updater({ pageIndex: currentFilters.page - 1, pageSize: currentFilters.page_size }) : updater;
    if (newState.pageIndex + 1 === currentFilters.page) return;
    setPage(newState.pageIndex + 1);
  }
};

export const handlePageSizeChange = (page_size: PAGE_SIZE) => {
  const currentFilters = typedQueryClient.getQueryData(DMSv3MonitoringDahsboardQueryKeys.filters);
  if (currentFilters) {
    setPreference(DMSV3_MONITORING_STORAGE_KEYS.PageSizePreference, page_size);
    typedQueryClient.setQueryData(DMSv3MonitoringDahsboardQueryKeys.filters, { ...currentFilters, page_size, page: 1 });
  }
};
